.container {
    padding: 28px 32px 24px;
    min-width: 520px;
    max-width: 600px;
    font-family: monospace;
    position: relative;
    animation: modalFadeIn 0.2s ease-out;
}

@keyframes modalFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.closeButton {
    position: absolute;
    top: 12px;
    right: 16px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #555;
}

.closeButton:hover {
    color: #000;
}

.title {
    margin: 0 0 4px;
    font-family: monospace;
}

.titleUnderline {
    width: 48px;
    height: 3px;
    background: #0078d4;
    border-radius: 2px;
    margin-bottom: 14px;
}

.description {
    font-size: 13px;
    color: #555;
    margin: 0 0 20px;
}

.successMessage {
    text-align: center;
    padding: 24px 0;
    color: #107c10;
    font-weight: 600;
}

.field {
    margin-bottom: 16px;
}

.label {
    display: block;
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 6px;
    font-family: monospace;
}

.required {
    color: #c00;
}

.qaList {
    max-height: 240px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fafafa;
}

.emptyQA {
    padding: 12px;
    color: #888;
    font-size: 13px;
}

.qaPair {
    padding: 10px 12px;
    border-bottom: 1px solid #eee;
}

.qaPair:last-child {
    border-bottom: none;
}

.question {
    font-size: 12px;
    color: #666;
    margin-bottom: 6px;
    display: flex;
    gap: 8px;
}

.qLabel {
    min-width: 76px;
}

.errorMessage {
    color: #c00;
    font-size: 12px;
    margin-bottom: 10px;
}

.actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}
